import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LearnComponent } from './learn/learn.component';
import { LearnByCourseComponent } from './learn-by-course/learn-by-course.component';
import { MyclassComponent } from './myclass/myclass.component';
import { MySessionsComponent } from './my-sessions/my-sessions.component';
const routes: Routes = [
    {
        path: '',
        children: [ {
            path: '',
            component: LearnComponent
        },
        {
            path: 'learn-by-course/:slug',
            component: LearnByCourseComponent
        },
        {
            path: 'my-classes/:id',
            component: MyclassComponent
        },
        {
            path: 'my-sessions/:id',
            component: MySessionsComponent
        }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LearnRoutingModule { }
